<div id="btn-shopping-cart" class="total-pieces cursor-pointer">
  <div class="car-icon-container" matTooltip="Ver carrito">
    <div class="car-icon">
      <img src="assets/icons/car.svg" alt="car" width="37" height="34" />
      <span>
        <p>{{ totalPieces }}</p>
      </span>
    </div>
  </div>
</div>
